import React, { useState, useEffect,useMemo } from "react";
import { useFetcher, useParams } from "react-router-dom";
import { Tabs, Spin, Form, Select } from "antd";
import { Line } from "react-chartjs-2";
import { Chart as GChart } from "react-google-charts";
import "./org-analytics.scss";
import userServiceApi from "../../api/userServiceApi";
import { getRequest } from "../../api/http";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import backArrow from "../../assets/images/back-arrow.svg";
import FilterIcon from "../../assets/images/filter_icon.svg";
import MonthlyVisitorsChart from "./MonthlyVisitorsChart";
import TabLineChart from "./TabLineChart";
import "./microsite-analytics.scss";
import {
  FilterOutlined,
} from '@ant-design/icons';
import PageViewChart from "./PageViewChart ";
import { getDateRange } from "../../utils/helper";
import Duration from "../duration-filter/duration";
import { GOOGLE_ANALYTICS_API_URL } from "../../api/http";

export default function MicrositeAnalytics() {

  const { micrositeId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;


  const currentYear = new Date().getFullYear();

  const [loader, setLoader] = useState(true);

  const [filterType, setFilterType] = useState();
  const [showYearDropdown, setShowYearDropdown] = useState(false);
  const [yearDropdownOptions, setYearDropdownOptions] = useState([]);
  const [selectedYear, setSelectedYear] = useState();

  const [showQuarterly, setShowQuarterly] = useState(false);
  const [selectedQuarter, setSelectedQuarter] = useState();
  const [showMonthly, setShowMonthly] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState();

  const [micrositeLineData, setMicrositeLineData] = useState(null);
  const [micrositeContactsAnalytics, setMicrositeContactsAnalytics] =
    useState(null);
  const [data, setData] = useState([]);
  const [tabData, setTabData] = useState([]);
  const [timeRange, setTimeRange] = useState("yearly");
  const [term, setTerm] = useState("yearly");
  const [year, setYear] = useState("2025");
  const [month, setMonth] = useState("01");
  const [quarter, setQuarter] = useState("1");
  const [selected, setSelected] = useState("International");
  const [responseData, setResponseData] = useState([]);
  const NATIONAL_COUNTRIES = ["England", "Northern Ireland", "Wales", "Scotland","United Kingdom"];







  const visitorsCount = async () => {

    try {
      setLoader(true)

    // Get start & end date from helper
    const { startDate, endDate } = getDateRange(term, year, month, quarter);

    // const countryResp = await fetch(`${GOOGLE_ANALYTICS_API_URL}/country?startDate=${startDate}&endDate=${endDate}`);
    // const countryDataResp = await countryResp.json();

    const pathViewers = await fetch(`${GOOGLE_ANALYTICS_API_URL}/path-viewers?startDate=${startDate}&endDate=${endDate}`);
    const pathViewersData = await pathViewers.json();
    setData(pathViewersData)

      

    const countryViews = await fetch(`${GOOGLE_ANALYTICS_API_URL}/country-viewers-by-path?path=/microsite/${encodeURI(state?.micrositeName.replace(" ", "_"))}&startDate=${startDate}&endDate=${endDate}`);
    const countries = await countryViews.json();
    setResponseData(countries);



    const tabClicks = await fetch(`${GOOGLE_ANALYTICS_API_URL}/tab-clicks?startDate=${startDate}&endDate=${endDate}`);
    const tabClicksResp = await tabClicks?.json();
    const pagePath = state?.micrositeName?.replace(" ", "_")
    const filtered = tabClicksResp?.filter(item => item?.pagePath === `/microsite/${pagePath}`);
    setTabData(filtered);
    } catch(error) {
      console.log('error',error)
    } finally {
      setLoader(false)
    }


     

  };



const formatCountryData = (responseData = [], pathFilter = null) => {
  if (!Array.isArray(responseData)) {
    return {
      nationalData: [],
      internationalData: [],
      sumOfNational: 0,
      sumOfInternational: 0,
    };
  }

  const national = [];
  const international = [];
  let sumOfNational = 0;
  let sumOfInternational = 0;

  responseData.forEach((item) => {
    // Filter by specific path if provided
    if (pathFilter && item.path !== pathFilter) return;

    const country = item?.country || "Unknown";
    const viewers = Number(item?.viewers || 0);
    const tooltip = `${country} - ${viewers} viewers`;

    if (NATIONAL_COUNTRIES.includes(country)) {
      national.push([country, viewers, tooltip]);
      sumOfNational += viewers;
    } else {
      international.push([country, viewers, tooltip]);
      sumOfInternational += viewers;
    }
  });

  return {
    nationalData: [["Country", "Viewers", { role: "tooltip", type: "string" }], ...national],
    internationalData: [["Country", "Viewers", { role: "tooltip", type: "string" }], ...international],
    sumOfNational,
    sumOfInternational,
  };
};



const { nationalData, internationalData,sumOfNational,sumOfInternational
 } = useMemo(() => {
  
    const countryData=[
    {
      dimensionValues: [{ value: "India", oneValue: "value" }],
      metricValues: [{ value: "2", oneValue: "value" }],
    },
    {
      dimensionValues: [{ value: "England", oneValue: "value" }],
      metricValues: [{ value: "5", oneValue: "value" }],
    },
     {
      dimensionValues: [{ value: "Wales", oneValue: "value" }],
      metricValues: [{ value: "2", oneValue: "value" }],
    },
  ];
  return formatCountryData(responseData);
  // return formatCountryData(countryData);

}, [responseData]);

 const optionsGA = {
    backgroundColor: "#f9fafb",
    datalessRegionColor: "#e0e0e0",
    defaultColor: "#f5f5f5",
    legend: { textStyle: { color: "#333" } },
    tooltip: {
      isHtml: true,
    },
    colorAxis: {
      colors: ["#10B981", "#2563EB"], // green → blue gradient
    },
  };

  
  const BarChartOptions2 = {
    title: "No. of users based on countries",
    hAxis: {
      title: "Total Population",
      minValue: 0,
    },
    vAxis: {
      title: "Country",
    },
  };

  
  const BarChartOptions = {
    title: "No. of users based on province",
    hAxis: {
      title: "Total Population",
      minValue: 0,
    },
    vAxis: {
      title: "Province",
    },
  };


  const getMicrositeAnalytics = async (id, month, year, quarter) => {
    // setSelectedMicrosite(name);
    try {
      const res = await getRequest(userServiceApi.getMicrositeAnalytics(id, month, year, quarter));
      let labels = [];
      let ViewsData = [];
      let SalesData = [];
      let HRData = [];
      let EowData = [];
      if (res && res.data) {
        res.data.map((month) => {
          labels.push(month.monthYear);
          ViewsData.push(month.count);
          SalesData.push(month.salesCount);
          HRData.push(month.hrCount);
          EowData.push(month.experienceOfWorkCount);
        });


        setMicrositeLineData({
          labels,
          datasets: [
            {
              label: "Views",
              data: ViewsData,
              // data: [24, 59, 76, 45, 14, 98, 87, 34, 56, 18, 54, 78],
              borderColor: "rgb(255, 99, 132)",
              backgroundColor: "rgba(255, 99, 132, 0.5)",
            },
          ],
        });

        setMicrositeContactsAnalytics({
          labels,
          datasets: [
            {
              label: "Sales",
              data: SalesData,
              borderColor: "rgb(255, 99, 132)",
              backgroundColor: "rgba(255, 99, 132, 0.5)",
            },
            {
              label: "HR",
              data: HRData,
              borderColor: "rgb(53, 162, 235)",
              backgroundColor: "rgba(53, 162, 235, 0.5)",
            },
            {
              label: "Experiences of Work",
              data: EowData,
              borderColor: "rgb(53, 192, 215)",
              backgroundColor: "rgba(53, 192, 215, 0.5)",
            },
          ],
        });
        setLoader(false);
        // if (micrositeLineData && micrositeContactsAnalytics) {

      }
    } catch (error) { }
  };

  useEffect(() => {
    // getMicrositeAnalytics(micrositeId)
  }, [])

  useEffect(() => {
    visitorsCount()
  }, [term, year, month, quarter])


  useEffect(() => {
    // getMicrositeAnalytics(
    //   micrositeId,
    //   // selectedAgeID,
    //   // selectedProfID,
    //   // ((filterType === "yearly" && selectedYear) ||
    //   //   (filterType === "monthly" && selectedMonth) ||
    //   //   (filterType === "quarterly" && selectedQuarter)) &&
    //   // filterType,
    //   filterType === "monthly" && selectedMonth,
    //   (filterType === "yearly" ||
    //     filterType === "monthly" ||
    //     filterType === "quarterly") &&
    //   selectedYear,
    //   filterType === "quarterly" && selectedQuarter
    // );
  }, [
    // selectedAgeID,
    // selectedProfID,
    selectedYear,
    selectedQuarter,
    selectedMonth,
  ]);

  const getYearsDropdown = () => {
    const currentYear = new Date().getFullYear();
    let yearsarray = [];
    for (let year = 2023; year <= currentYear + 20; year++) {
      yearsarray.push(year);
    }
    setYearDropdownOptions(yearsarray);
  };


  useEffect(() => {
    getYearsDropdown();
  }, []);

  const rawData = [
    {
      path: "/microsite/I-PHONE_Microsite",
      month: "202510",
      viewers: 1,
    },
  ];

  // Construct all months from Oct 2024 → Oct 2025
  const months = [];
  const monthLabels = [];
  for (let i = 0; i < 13; i++) {
    const date = new Date(2024, 9 + i, 1); // 9 = October (0-based)
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    months.push(`${year}${month}`); // e.g., "202410"
    const label = date.toLocaleString("default", { month: "long", year: "numeric" });
    monthLabels.push(label); // e.g., "October 2024"
  }

  // Map data to months, fill missing with 0
  const dataPoints = months.map((m) => {
    const found = rawData.find((d) => d.month === m);
    return found ? found.viewers : 0;
  });


  const dataset = {
    labels: monthLabels,
    datasets: [
      {
        label: "Viewers",
        data: dataPoints,
        borderColor: "rgba(75,192,192,1)",
        backgroundColor: "rgba(75,192,192,0.2)",
        tension: 0.4,
      },
    ],
  };

  const handleSelected = (value) => {
    setSelected(value);
  };

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          title: (tooltipItems) => {
            // Month on first line
            return tooltipItems[0].label;
          },
          label: (tooltipItem) => {
            // Viewers on second line
            return `Views: ${tooltipItem.raw}`;
          },
        },
      },
      legend: { display: false },
    },
    scales: {
      y: {
        beginAtZero: true,
        suggestedMin: 0,
        suggestedMax: 3,
        ticks: {
          stepSize: 0.5,
          padding: 5,
        },
        title: { display: true, text: "Viewers" },
      },
      x: {
        title: { display: true, text: "Month" },
        ticks: { maxRotation: 45, minRotation: 0 },
      },
    },
  };


  //microsite popup graph data
  const ModalLineoptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: false,
        text: "",
      },
      datalabels: {
        formatter: Math.round,
        anchor: "end",
        offset: -20,
        align: "start",
      },
    },
  };

  // if (loader) {
  //   return (
  //     <div className="tabContainer analytics-tab">
  //       {/* <Tabs defaultActiveKey="1" className="analytics-tab">
  //         <Tabs.TabPane tab="Microsite Analytics" key={"1"}> */}
  //       <div className="data-loader">
  //         <Spin tip="Loading" size="large" />
  //       </div>
  //       {/* </Tabs.TabPane>
  //       </Tabs> */}
  //     </div>
  //   );
  // } else {
    return (
      <div className="tabContainer">
        <div className="header page-header">
          <div className="backbtn-container">
            <img src={backArrow} alt="" onClick={() => state.page === "home" ? navigate('/') : navigate('/org-analytics')} />
            <p>{state.micrositeName}</p>
          </div>
        </div>



        <div className="analytics-tab">
          {/* <Tabs defaultActiveKey="1" className="analytics-tab">
          <Tabs.TabPane tab="Microsite Analytics" key={"1"}> */}
          <div className="microsite-analytics">
            <div className="filter-box">
              {/* <p className="filters-heading">Filters</p>   */}
              <div className="add-filter-btns">
                <Form.Item className="term-select"
                  label={
                    <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <img
                        src={FilterIcon}
                        alt="Filter"
                        style={{ width: 16, height: 16 }}
                      />
                      Term
                    </span>
                  } colon={false}>
                  <Select
                    allowClear
                    className="customSelect"
                    // placeholder={firstValue}
                    placeholder="Select Term"
                    value={filterType}
                    onChange={(e) => {
                      setFilterType(e);
                      setTimeRange(e);
                      setTerm(e)
                      if (e == "quarterly") {
                        setShowMonthly(false);
                        setSelectedMonth();
                        setSelectedYear();
                        setSelectedQuarter();
                        setShowYearDropdown(true);
                        setShowQuarterly(true);
                      } else if (e == "monthly") {
                        setSelectedMonth();
                        setSelectedYear();
                        setSelectedQuarter();
                        setShowYearDropdown(true);
                        setShowQuarterly(false);
                        setShowMonthly(true);
                      } else if (e == "yearly") {
                        setSelectedMonth();
                        setSelectedYear();
                        setSelectedQuarter();
                        setShowMonthly(false);
                        setShowQuarterly(false);
                        setShowYearDropdown(true);
                      }
                    }}
                    onClear={() => {
                      setFilterType();
                      setSelectedYear();
                      setSelectedMonth();
                      setSelectedQuarter();
                      setShowYearDropdown(false);
                      setShowMonthly(false);
                      setShowQuarterly(false);
                      setTimeRange("yearly")
                    }}
                    options={[
                      {
                        value: "yearly",
                        label: "Yearly",
                      },
                      {
                        value: "monthly",
                        label: "Monthly",
                      },
                      {
                        value: "quarterly",
                        label: "Quarterly",
                      },
                    ]}
                  ></Select>
                </Form.Item>
                {showYearDropdown && (
                  <Form.Item className="term-select" label="Year" colon={false}>
                    <Select
                      allowClear
                      className="customSelect"
                      placeholder="Select Year"
                      value={selectedYear}
                      onChange={(e) => {
                        setSelectedYear(e);
                        setYear(e);
                      }}
                      onClear={() => {
                        setSelectedYear();
                        setSelectedMonth();
                        setSelectedQuarter();
                        setShowQuarterly(false);
                        setShowMonthly(false);
                        setShowYearDropdown(false);
                        setFilterType();
                        setYear();

                      }}
                    >
                      {yearDropdownOptions.length > 0 &&
                        yearDropdownOptions.map((year, i) => (
                          <Select.Option
                            disabled={year > currentYear ? true : false}
                            key={year}
                            value={year}
                          >
                            {year}
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                )}
                {showMonthly && (
                  <Form.Item className="term-select" label="Month" colon={false}>
                    <Select
                      allowClear
                      className="customSelect"
                      // placeholder={firstValue}
                      disabled={selectedYear ? false : true}
                      placeholder="Select Month"
                      value={selectedMonth}
                      onChange={(e) => {
                        setSelectedMonth(e);
                        setMonth(e)
                      }}
                      onClear={() => {
                        setSelectedMonth();
                        setSelectedYear();
                        setMonth();
                        setYear();
                        // setFilterType();
                        // setShowMonthly(false);
                        // setShowYearDropdown(false);
                      }}
                      options={[
                        { value: "January", label: "January" },
                        { value: "February", label: "February" },
                        { value: "March", label: "March" },
                        { value: "April", label: "April" },
                        { value: "May", label: "May" },
                        { value: "June", label: "June" },
                        { value: "July", label: "July" },
                        { value: "August", label: "August" },
                        { value: "September", label: "September" },
                        { value: "October", label: "October" },
                        { value: "November", label: "November" },
                        { value: "December", label: "December" },
                      ]}
                    ></Select>
                  </Form.Item>
                )}
                {showQuarterly && (
                  <Form.Item className="term-select" label="Quarter" colon={false}>
                    <Select
                      allowClear
                      className="customSelect"
                      // placeholder={firstValue}
                      placeholder="Select Quarter"
                      value={selectedQuarter}
                      disabled={selectedYear ? false : true}
                      onChange={(e) => {
                        setSelectedQuarter(e);
                        setQuarter(e);
                      }}
                      onClear={() => {
                        setSelectedQuarter();
                        // setFilterType();
                        setSelectedYear();
                        setQuarter();
                        setYear();
                        // setShowQuarterly(false);
                        // setShowYearDropdown(false);
                      }}
                      options={[
                        {
                          value: "1",
                          label: "Q1",
                        },
                        {
                          value: "2",
                          label: "Q2",
                        },
                        {
                          value: "3",
                          label: "Q3",
                        },
                        {
                          value: "4",
                          label: "Q4",
                        },
                      ]}
                    ></Select>
                  </Form.Item>
                )}
              </div>
            </div>

              <div className="overall-views-graph">
             {loader ?     <div className="data-loader">
          <Spin tip="Loading" size="large" />
        </div> :  <div className="microsite-data">

                <div className="selection-container" style={{ display: "flex", alignItems: "center" }}>
                  <Duration
                    options={["National", "International"]}

                    selected={handleSelected}
                  />
                   <div className="user-count">
                <p className="total-count">
                        { selected === "National"
                      ? sumOfNational
                      : sumOfInternational}
                </p>
                <div className="count-label">
                  <p>{`${selected === "Local"
                    ? `Local`
                    : selected === "National"
                      ? `National`
                      : `International`
                    }`}</p>
                  <p>No. of users</p>
                </div>
              </div>
                 
                </div>
                <div className="users-by-map">
                  { selected === "National" ? (
                    nationalData?.length > 1 ? (

                      <div className="charts">
                        <div className="geoChart">
                          <GChart
                            className="gchart"
                            chartType="GeoChart"
                            width="100%"
                            height="400px"
                            loader={true}
                            data={nationalData}
                            options={optionsGA}
                          />
                        </div>
                        <div className="barChart">
                          <GChart
                            className="gchart"
                            chartType="BarChart"
                            width="100%"
                            height="400px"
                            loader={true}
                            data={nationalData}
                            options={BarChartOptions}
                          />
                        </div>
                      </div>
                    ) : (
                      <>
                        <p className="sub-header">No data available</p>
                      </>
                    )
                  ) : internationalData?.length > 1 ? (

                    <div className="charts">
                      <div className="geoChart" style={{ height: "500px" }}>
                        <GChart
                          className="gchart"
                          chartType="GeoChart"
                          height="400px"
                          width="100%"
                          data={internationalData}
                          options={optionsGA}
                        />
                      </div>
                      <div className="barChart" style={{ height: "500px" }}>
                        <GChart
                          className="gchart"
                          chartType="BarChart"
                          width="100%"
                          height="400px"
                          data={internationalData}
                          options={BarChartOptions2}
                        />
                      </div>
                    </div>
                  ) : (
                    <p className="sub-header">No data available</p>
                  )}
                </div>
              </div> } 
        
       
            </div>  


            <div className="overall-views-graph">
              {data && (
                <div className="microsite-data">
                  <h2 className="modal-sub-heading">
                    <b>Views</b>
                  </h2>
                  <div className="graph-wrapper">
                    {/* <Line
                      options={ModalLineoptions}
                      height={"250px"}
                      data={micrositeLineData}
                    /> */}

                    <PageViewChart responseData={data} micrositeName={state?.micrositeName} monthName={month} quarter={quarter} term={term} year={year} key={data?.id} />
                  </div>
                </div>
              )}
              {/* 
              {micrositeLineData && (
                <div className="microsite-data">
                  <h2 className="modal-sub-heading">
                    <b>Views</b>
                  </h2>
                  <div className="graph-wrapper">
                    <Line
                      options={ModalLineoptions}
                      height={"250px"}
                      data={micrositeLineData}
                    />
                  </div>
                </div>
              )} */}
            </div>
            <div>

            </div>
            <div className="overall-views-graph" style={{ marginTop: "15px" }}>
              {tabData && (
                <div className="microsite-data">
                  <h2 className="modal-sub-heading">
                    <b>Sales vs HR vs Experiences of work</b>
                  </h2>
                  <div className="graph-wrapper">
                    <TabLineChart type='click' micrositeName={state?.micrositeName} data={tabData} monthName={month} month={month} quarter={quarter} term={term} year={year} />
                  </div>
                </div>
              )}

              {/* {micrositeContactsAnalytics && (
                <div className="microsite-data">
                  <h2 className="modal-sub-heading">
                    <b>Sales vs HR vs Experiences of work</b>
                  </h2>
                  <div className="graph-wrapper">
                    <Line
                      options={ModalLineoptions}
                      height={"250px"}
                      data={micrositeContactsAnalytics}
                    />
                  </div>
                </div>
              )} */}
            </div>
          </div>
        </div>
        {/* </Tabs.TabPane>
        </Tabs> */}
      </div>
    );
  // }
}
